import { Component, OnChanges, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import {IncidentDto, LandTitleDto, StateDto, CommunityDto, LgaDto, ImpactedAssetDto} from '@cradua/data';
import { IncidentassetpopupComponent } from './../../incidentassetpopup/incidentassetpopup.component';
import { FormBuilder, FormGroup, FormArray } from "@angular/forms";
import Swal from "sweetalert2";

@Component({
    selector: 'cradua-impactedasset',
    templateUrl: './impactedasset.component.html',
    styleUrls: ['./impactedasset.component.scss']
  })
  export class ImpactedAssetComponent implements OnInit, OnChanges {

    @Input() landTitles: LandTitleDto[];
    @Input() impactedassets: ImpactedAssetDto[];
    @Input() selectedIncidentId: IncidentDto;

    @Output() emitSave = new EventEmitter<ImpactedAssetDto>();
    @Output() deleteEvent = new EventEmitter<any>();
    filteredDelete: Array<any> =[];
    @Input() states: StateDto[];
    @Input() communitys: CommunityDto[];
    @Input() lgas: LgaDto[];
    //selectedIncidentId:IncidentDto;
    impactedAssetForm: FormGroup;
    impactedAssetFormArray: FormGroup;
    listView = true;
    gridView = false;

    constructor( public dialog: MatDialog, private fb: FormBuilder, private cdr: ChangeDetectorRef){}

    ngOnInit(): void {
      //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
      //Add 'implements OnInit' to the class.
      this.createImpactedAssetForm();


    }

    ngOnChanges(){

// this.cdr.detectChanges();
}


createImpactedAssetForm(){

    this.impactedAssetForm = this.fb.group({ ImpactedAssets: this.fb.array([])
      });

      if(this.selectedIncidentId != null && this.selectedIncidentId.impactedassets?.length){
        this.setImpactedAsset(this.selectedIncidentId.impactedassets);
      }

}

addNonReferenceAsset() {
  const control = this.impactedAssetForm.controls.ImpactedAssets as FormArray;


    control.push(this.fb.group({

      Remarks: [''],
       LandName: [''],
        LandTitleId: [''],
        StateName: [''],
        LgaName: [''],
        CommunityName: [''],
        LandSerialNo: this.selectedIncidentId.id
        })
   );

}

 control() {
   return this.impactedAssetForm.controls.ImpactedAssets as FormArray;
 }

 setImpactedAsset(impactedassets: ImpactedAssetDto[]) {
  impactedassets.forEach(value => {
    this.control().push(this.fb.group({
      Remarks: value.Remarks,
      CommunityName:value.CommunityName,
      LgaName:value.LgaName,
      StateName: value.StateName,
      LandName:value.LandName,
      id: value.id,
      LandSerialNo: value.LandSerialNo,
    }))
  })

}


    onPopUpDisplay(event) {
        const listdata = [];


        event.map(dat => {

          const data  = {
            StateName:  dat.StateName,
            LgaName: dat.LgaName,
            CommunityName: dat.CommunityName,
            LandName: dat.LandName,
            StateId: dat.StateId,
            LgaId: dat.LgaId,
            CommunityId: dat.CommunityId,
            LandSerialNo: this.selectedIncidentId.id,
            SubscriberId: dat.SubscriberId,
            SubscriptionUserId: dat.SubscriptionUserId,
          };
          listdata.push(data);

        });

        const senddata = {listdata: listdata, impactedassets: this.impactedassets }
        const dialogRef = this.dialog
          .open(IncidentassetpopupComponent, {
            data: senddata,
            height: 'auto',
            width: '900px'
          })
          .afterClosed()
          .subscribe(datum => {
            if(datum) {
              const control = this.impactedAssetForm.controls.ImpactedAssets as FormArray;
              datum.forEach(e => {

                control.push(this.fb.group({

                  Remarks: e[0].Remarks,
                   LandName: e[0].LandName,
                    LandTitleId: e[0].id,
                    StateName: e[0].StateName,
                    LgaName: e[0].LgaName,
                    CommunityName: e[0].CommunityName,
                    LandSerialNo: this.selectedIncidentId.id
                    })
               );

              });

            }

          });
      }


      onSubmit() {


        if(this.impactedAssetForm.valid){
          this.emitSave.emit(this.impactedAssetForm.value.ImpactedAssets);
        }
        // console.log("filtered delete", this.impactedAssetForm.value.ImpactedAssets, this.filteredDelete);
        if(this.filteredDelete.length > 0) {
          this.deleteEvent.emit(this.filteredDelete);
        }
      }



      deleteImpactedAsset(value, index) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this imaginary file!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it'
        }).then((result) => {
          if (result.value) {
    //  console.log("remove at", value);
      this.control().removeAt(index);
      if(value.id != null) {

        this.filteredDelete.push(value);
      }
      // for ( let i = 0; i < this.impactedassets.length; i++) {
      //     if (i === index) {
      //       if (value.id !== null) {
      //         this.filteredDelete.push(this.impactedassets[i].id);
      //        }

      //     }
      //   }
      Swal.fire(
              'Deleted!',
              'Your imaginary file has been deleted.',
              'success'
            );
          } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.fire(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              );
            }
          });
      }



      onList() {
        this.listView = true;
        this.gridView = false;
      }

      onGrid() {
        this.gridView = true;
        this.listView = false;
      }
  }
